export const msToTime = (duration) => {
    var minutes = Math.floor((duration / (1000 * 60)) % 60);
    var hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    return hours + ":" + minutes + ' ' + ampm
}

export const getDateWeek = (dateString) => {
    const date = new Date(dateString);
    const monthsOfYear = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dayOfMonth = date.getDate();
    const monthOfYear = monthsOfYear[date.getMonth()];
    var minutes = Math.floor((dateString / (1000 * 60)) % 60);
    var hours = Math.floor((dateString / (1000 * 60 * 60)) % 24);
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    const formattedDate = `${monthOfYear} ${dayOfMonth} , ${hours}:${minutes} ${ampm}`
    return formattedDate
}